<template>
  <a-modal
    :title="'设置保证金'"
    :maskClosable="false"
    :width="640"
    :confirmLoading="confirmLoading"
    :visible="visible"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
    <!-- 保证金金额 -->
      <a-form-item label="保证金金额/元" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input-number
          :min="0"
          :max="100000"
          style="width: 100%"
          v-decorator="[
            'bailAmount',
            {rules: [{ required: true, message: '请输入' }]}
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import institution from '../../api/institution'

export default {
  name: 'institutionAmountModal',
  data(){
    return{
      visible: false, 
      confirmLoading: false,
      form: this.$form.createForm(this),
      institutionId: '',
    }
  },
  methods:{
    //初始化，显示
    init(params) {
      this.visible = true;
      this.institutionId = params.id;
      //金额存在，需要回显
      if (params.bailAmount) {
        let formData = {};
        formData.bailAmount = params.bailAmount / 100;
        setTimeout(() => {
          this.form.setFieldsValue(formData);
        }, 100);
      } else {
        this.form.resetFields();
        this.sourceFileList = [];
      }
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, value) => {
        console.log("输入的内容是：", value);
        if (!err) {
          this.confirmCashDeposit(value);
        }
      });
    },

     //确认保证金
    confirmCashDeposit(value){
      let params = {
        bailAmount: value.bailAmount * 100, //元转换为分
        id: this.institutionId,
      }
      institution.confirmCashDeposit(params).then(res=>{
        this.$message.success("设置保证金成功")
        this.handleCancel();
        this.$emit('updateData',res.data)
      })
    },

    //隐藏
    handleCancel() {
      this.visible = false;
    },

  }

  
}
</script>